/**

Job Search
careers_click_jobsearch - click on "Search" button
careers_click_jobsearch_employersbutton - click on "Employers" button (which launches modal)
careers_click_jobsearch_signincreateprofile -  click on "SIGN IN" or "CREATE A JOB SEEKER PROFILE" links
careers_click_jobsearch_employerslink - Tap on "Employers Click Here"
careers_click_jobsearch_changelocation - Tap on "Change Location"

Employer (modal)
careers_click_employermodal_postjobregister - click on "Post a Job or Register" button
careers_click_employermodal_signin - click on "Sign in" button
careers_click_employermodal_forgot - click on "Forgot Login.." link
careers_click_employermodal_learnmore - "Learn More" buttons on the 3 columns

Job Categories
careers_click_jobcategories_item - categories boxes
careers_click_jobcategories_more - "More" button
careers_click_jobcategories_less - "Less" button

Job Seeker Resources
careers_click_jobseekerresources_careeradvice_viewmore - Career Advice box, "View More" button
careers_click_jobseekerresources_jobnews_viewmore - Job News box, "View More" button

Employer Showcase
careers_click_employershowcase_learnmore - click on any "Learn More" button in each column
careers_click_employershowcase_logo - click on any logo in each column
careers_click_employershowcase_readmore - click on any "Read More" within the company description

Employer (CTA)
careers_click_employercta_postjob - click on "Post a Job" or "Employer Sign in/Register" button
careers_click_employercta_eeolearnmore - click on "Learn more" link at bottom;

**/

const CareersTracker3 = {
	clickTrackMap: [
		[
			"#searchbutton",
			function() {
				let search_term = document.getElementById('jobtitle_id').value;
				let search_location = document.getElementById('location_id').value;
				let label = "search_term:" + search_term + "||search_location:" + search_location;

				return {
					action: "careers_click_jobsearch",
					label: label,
					category: "careers"
				};
			}
		],
		[".btn_wrap.trigger .adv_search_btn", { action: "careers_click_jobsearch_employersbutton", category: "careers" }],
		[".section--jobsearch .section__foot .footlinks", { action: "careers_click_jobsearch_signincreateprofile", category: "careers" }],
		[".section--jobsearch #click_here", { action: "careers_click_jobsearch_employerslink", category: "careers", label: "mobile" }],
		[".section--jobsearch #loc_changer", { action: "careers_click_jobsearch_changelocation", category: "careers", label: "mobile" }],
		[".section--employermodal #emp_modal_post_a_job span", { action: "careers_click_employermodal_postjobregister", category: "careers" }],
		[".section--employermodal #emp_modal_sign_in span", { action: "careers_click_employermodal_signin", category: "careers" }],
		[".section--employermodal .forgot_link", { action: "careers_click_employermodal_forgot", category: "careers" }],
		[".section--employermodal .learnmore_button", { action: "careers_click_employermodal_learnmore", category: "careers" }],
		[".category_cell", { action: "careers_click_jobcategories_item", category: "careers" }],
		["#more_categs .more_button", { action: "careers_click_jobcategories_more", category: "careers" }],
		["#less_categs .more_button", { action: "careers_click_jobcategories_less", category: "careers" }],
		[".section--jobseekerresources #box1 .viewmore_button", { action: "careers_click_jobseekerresources_careeradvice_viewmore", category: "careers" }],
		[".section--jobseekerresources #box2 .viewmore_button", { action: "careers_click_jobseekerresources_jobnews_viewmore", category: "careers" }],
		[".section--employershowcase .learnmore_button", { action: "careers_click_employershowcase_learnmore", category: "careers" }],
		[".section--employershowcase .logo-wrap", { action: "careers_click_employershowcase_logo", category: "careers" }],
		[".section--employershowcase .company-profile a", { action: "careers_click_employershowcase_readmore", category: "careers" }],
		[".section--employercta .viewmore_button", { action: "careers_click_employercta_postjob", category: "careers" }],
		[".section--employercta .section__foot p a", { action: "careers_click_employercta_eeolearnmore", category: "careers" }]
	], //END: clickTrackMap

	init: function() {
		//initialize any variables and objects here
		//window.adiTrackPromise = window.adiTrackPromise || $.Deferred();

		//Only do main stuff when adiTrack object is ready
		CareersTracker3.clickTrackMap.forEach(CareersTracker3.attachClickTracking);
		console.log("CareersTracker3 initialized.");
	}, //END: init

	attachClickTracking: function(ar) {
		let timesRun = 0;
		let selector = ar[0];
		let adiTrackPayload = ar[1];
		let myConfig = { affiliateList: ["all"] };

		let poller = setInterval(function() {
			let selected = document.querySelector(selector);
			timesRun++;
			if (timesRun > 777 && poller) {
				//if modules take too long or never truly load, then stop polling;
				console.log("element took too long to load. Moving on...");
				clearInterval(poller);
			} else if (selected !== null) {
				//clear interval as soon as element is found
				console.log("Element found!");
				clearInterval(poller);
				console.log("Poller cleared!");
				//attach click event
				console.log("attaching click event trigger...");
				selected.onclick = function() {
					if (typeof adiTrackPayload === "function") {
						adiTrackPayload = adiTrackPayload();
					}
					adiTrackPromise.then(function() {
						adiTrack.event(adiTrackPayload, myConfig);
						console.log("click event tracking successfully fired for " + adiTrackPayload);
					});
				}
			}
		}, 500); //setInterval
	} //.attachClickTracking
}; //END: CareersTracker3;

document.addEventListener("DOMContentLoaded", function(event) {
  CareersTracker3.init();
});

window.CareersTracker3 = CareersTracker3;
